import { useEffect } from "react";

function setMeta(selector, attrs) {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => k !== "content" && tag.setAttribute(k, v));
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", attrs.content);
}

export function useSEO({ title, description }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta('meta[property="og:title"]', { property: "og:title", content: title });
      setMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    }
    if (description) {
      setMeta('meta[name="description"]', { name: "description", content: description });
      setMeta('meta[property="og:description"]', { property: "og:description", content: description });
      setMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    }
  }, [title, description]);
}

export default useSEO;
